import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { Popover, Slide } from "@mui/material";
import $ from "jquery";
import { useEffect, useState } from "react";
import { render } from "react-dom";
import { addViewportIsMobileListener, getViewportIsMobile, isNotUndefined, isNotUndefinedOrNull, track_event, trackDataMaskIconClickEvents } from "../FunctionsCore";
import { classCombinerFromPrefix } from "../RenderIdentifier";
import DataMaskingStyles from "./DataMaskingStyles.module.scss";
const styles = DataMaskingStyles;
const classCombiner = classCombinerFromPrefix("eea7013e1ac224f9");
const trackDataMaskingIcon = (currentTarget) => {
    $(() => {
        if (isNotUndefined(currentTarget)) {
            const dataFieldName = $(currentTarget).parent().parent().attr("data-tracking-name");
            trackDataMaskIconClickEvents(dataFieldName);
        }
    });
};
const DataMaskingDunsComponent = (properties) => {
    const handleRedirect = () => {
        window.open(properties.dnbUpikPath, "_blank");
    };
    return (_jsx("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingWrapper")) }, { children: _jsx("button", Object.assign({ className: cx("dataMaskingLockIconWrapper", classCombiner(styles, "dataMaskingLockIconWrapper")), onClick: handleRedirect, type: "button" }, { children: _jsx("div", { className: cx(classCombiner(styles, "dataMaskingLockIcon")) }) })) })));
};
const DataMaskingCoreComponent = (properties) => {
    const { buttonLabel, buttonLink, heading, showOnTop, text } = properties;
    const invisible = !showOnTop;
    const [anchorEl, setAnchorEl] = useState();
    const [elementWidth, setElementWidth] = useState();
    const [viewportIsMobile, setViewportIsMobile] = useState(false);
    useEffect(() => {
        setViewportIsMobile(getViewportIsMobile());
        addViewportIsMobileListener((bo) => setViewportIsMobile(bo));
    }, []);
    const handleClose = () => setAnchorEl(void 0);
    return (_jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingWrapper")) }, { children: [_jsx("button", Object.assign({ className: cx("dataMaskingLockIconWrapper", classCombiner(styles, "dataMaskingLockIconWrapper")), onClick: (re) => {
                    const currentTarget = re.currentTarget;
                    if (showOnTop) {
                        window.document
                            .querySelectorAll(".dnbHooversFreeTrialCtaLink")
                            .forEach((ele) => {
                            const rect = ele.getBoundingClientRect();
                            if (rect.top > 0) {
                                setAnchorEl(ele);
                                const width = ele.clientWidth + 1;
                                setElementWidth(width);
                            }
                        });
                    }
                    else {
                        setAnchorEl(currentTarget);
                    }
                    trackDataMaskingIcon(currentTarget);
                }, type: "button" }, { children: _jsx("div", { className: cx(classCombiner(styles, "dataMaskingLockIcon")) }) })), _jsx(Popover, Object.assign({}, (viewportIsMobile
                ?
                    {
                        "anchorOrigin": {
                            "horizontal": "left",
                            "vertical": "top",
                        }
                    }
                : {
                    "anchorOrigin": {
                        "horizontal": "right",
                        "vertical": "top",
                    },
                    "transformOrigin": {
                        "horizontal": "right",
                        "vertical": "top",
                    }
                }), { BackdropProps: { "invisible": invisible }, anchorEl: anchorEl, className: cx(showOnTop ? "dataMaskContainer" : void 0), id: isNotUndefined(anchorEl) ? "dataMaskingPopover" : void 0, onClose: handleClose, open: isNotUndefined(anchorEl) }, { children: _jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingGetADAndBHooversFreeTrialLinkWrapper")) }, { children: _jsx("a", Object.assign({ className: cx(classCombiner(styles, "dataMaskingGetADAndBHooversFreeTrialLink"), showOnTop ? classCombiner(styles, "dataMaskingGetADAndBHooversFreeTrialLinkExtended") : ""), href: buttonLink, onClick: () => {
                                    track_event(`${buttonLabel} clicked`);
                                }, style: isNotUndefined(elementWidth)
                                    ?
                                        {
                                            "width": `${elementWidth}px`
                                        }
                                    : void 0 }, { children: buttonLabel })) })), _jsx(Slide, Object.assign({ direction: "up", in: isNotUndefined(anchorEl), mountOnEnter: true, unmountOnExit: true }, { children: _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModal"), showOnTop ? classCombiner(styles, "dataMaskingModalExtended") : "") }, { children: [_jsx("button", { className: cx(classCombiner(styles, "dataMaskingModalCloseButton"), showOnTop ? classCombiner(styles, "dataMaskingModalCloseButtonExtended") : ""), onClick: handleClose, type: "button" }), _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModalBody")) }, { children: [_jsx("div", { className: cx(classCombiner(styles, "dataMaskingLockIconGray")) }), _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModalTextSection")) }, { children: [_jsx("p", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModalHeading")) }, { children: heading })), _jsx("p", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModalText")) }, { children: text }))] }))] }))] })) }))] }) }))] })));
};
const MaskDynamicComponent = (properties) => {
    const { buttonAction, buttonLabel, text } = properties;
    const [anchorElement, setAnchorElement] = useState();
    const handleClick = (re) => {
        const currentTarget = re.currentTarget;
        setAnchorElement(currentTarget);
        trackDataMaskingIcon(currentTarget);
    };
    const handleClose = () => setAnchorElement(void 0);
    const anchorElementIsNotUndefined = isNotUndefined(anchorElement);
    const id = anchorElementIsNotUndefined ? "dataMaskingPopover" : "";
    return (_jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingWrapper")) }, { children: [_jsx("button", Object.assign({ className: cx(classCombiner(styles, "dataMaskingLockIconWrapper")), onClick: handleClick, type: "button" }, { children: _jsx("div", { className: cx(classCombiner(styles, "dataMaskingLockIcon")) }) })), _jsx(Popover, Object.assign({ anchorEl: anchorElement, anchorOrigin: {
                    "horizontal": "left",
                    "vertical": "bottom",
                }, id: id, onClose: handleClose, open: anchorElementIsNotUndefined }, { children: _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModal")) }, { children: [_jsx("button", { className: cx(classCombiner(styles, "dataMaskingModalCloseButton")), onClick: handleClose, type: "button" }), _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModalBody")) }, { children: [_jsx("div", { className: cx(classCombiner(styles, "dataMaskingLockIconGray")) }), _jsx("p", Object.assign({ className: cx(classCombiner(styles, "dataMaskingModalText")) }, { children: text }))] })), _jsx("div", Object.assign({ className: cx(classCombiner(styles, "dataMaskingGetADAndBHooversFreeTrialLinkWrapper")) }, { children: _jsx("a", Object.assign({ className: cx(classCombiner(styles, "dataMaskingGetADAndBHooversFreeTrialLink")), onClick: () => {
                                    buttonAction();
                                    handleClose();
                                } }, { children: buttonLabel })) }))] })) }))] })));
};
const DataMaskingComponent = (properties) => {
    var _a, _b, _c;
    return _jsx(DataMaskingCoreComponent, { buttonLabel: (_a = properties.dnbHooversFreeTrialBtnText) !== null && _a !== void 0 ? _a : "Get a D&B Hoovers Free Trial", buttonLink: properties.hooversFreeTrialDirectoryPathRewritten, heading: (_b = properties.dnbHooversFreeTrialHeadlineLocalized) !== null && _b !== void 0 ? _b : "D&B Hoovers unlocks contact details and business information", showOnTop: true, text: (_c = properties.dnbHooversFreeTrialDescriptionLocalized) !== null && _c !== void 0 ? _c : "Get a free trial of D&B Hoovers today and unlock access to the business data that matters to you." });
};
const DataMaskingCreditReportsComponent = (properties) => {
    var _a, _b;
    return _jsx(MaskDynamicComponent, { buttonAction: () => {
            window.location.href = properties.buyCreditReportsDirectoryPathRewritten;
        }, buttonLabel: (_a = properties.dataMaskingRevenueBtnLocalised) !== null && _a !== void 0 ? _a : "Buy Credit Reports", text: (_b = properties.dataMaskingRevenueDescriptionLocalised) !== null && _b !== void 0 ? _b : "Looking for more detailed business information? Proactively manage credit relationships with a D&B credit report." });
};
const dataMasking = (maskingProperties) => {
    const $bodyAsterisk = $("body *");
    const $firstHack = $bodyAsterisk.filter((_, ht) => {
        const firstChildNode = ht.childNodes[0];
        if (isNotUndefinedOrNull(firstChildNode)) {
            const firstChildNodeNodeValue = firstChildNode.nodeValue;
            if (isNotUndefinedOrNull(firstChildNodeNodeValue)) {
                return firstChildNodeNodeValue.includes("?\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ");
            }
        }
        return false;
    });
    const $secondHack = $(".title-ctr > .count").filter((_, ht) => {
        const firstChildNode = ht.childNodes[0];
        if (isNotUndefinedOrNull(firstChildNode)) {
            const firstChildNodeNodeValue = firstChildNode.nodeValue;
            if (isNotUndefinedOrNull(firstChildNodeNodeValue)) {
                return firstChildNodeNodeValue === "9,999";
            }
        }
        return false;
    });
    for (const ht of $firstHack.add($secondHack)) {
        $(ht).html("");
        // TODO Restore StrictMode
        // https://levelup.gitconnected.com/react-18-the-trickiness-of-useeffect-fadfa65fa4b4
        render(_jsx(DataMaskingComponent, { dnbHooversFreeTrialBtnText: maskingProperties.dnbHooversFreeTrialBtnText, dnbHooversFreeTrialDescriptionLocalized: maskingProperties.dnbHooversFreeTrialDescriptionLocalized, dnbHooversFreeTrialHeadlineLocalized: maskingProperties.dnbHooversFreeTrialHeadlineLocalized, hooversFreeTrialDirectoryPathRewritten: maskingProperties.hooversFreeTrialDirectoryPathRewritten }), ht);
    }
    const $thirdHack = $bodyAsterisk.filter((_, ht) => {
        const firstChildNode = ht.childNodes[0];
        if (isNotUndefinedOrNull(firstChildNode)) {
            const firstChildNodeNodeValue = firstChildNode.nodeValue;
            if (isNotUndefinedOrNull(firstChildNodeNodeValue)) {
                return firstChildNodeNodeValue.includes("#\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ");
            }
        }
        return false;
    });
    for (const ht of $thirdHack) {
        $(ht).html("");
        // TODO Restore StrictMode
        // https://levelup.gitconnected.com/react-18-the-trickiness-of-useeffect-fadfa65fa4b4
        render(_jsx(DataMaskingCreditReportsComponent, { buyCreditReportsDirectoryPathRewritten: maskingProperties.buyCreditReportsDirectoryPathRewritten, dataMaskingRevenueBtnLocalised: maskingProperties.dataMaskingRevenueBtnLocalised, dataMaskingRevenueDescriptionLocalised: maskingProperties.dataMaskingRevenueDescriptionLocalised }), ht);
    }
    const $fourthHack = $bodyAsterisk.filter((_, ht) => {
        const firstChildNode = ht.childNodes[0];
        if (isNotUndefinedOrNull(firstChildNode)) {
            const firstChildNodeNodeValue = firstChildNode.nodeValue;
            if (isNotUndefinedOrNull(firstChildNodeNodeValue)) {
                return firstChildNodeNodeValue.includes("@\t\t \t \t  \t\t  \t \t \t\t\t\t \t  \t\t\t   \t\t\t  \t\t  \t\t\t \t\t \t\t  \t\t \t\t\t\t   \t \t ");
            }
        }
        return false;
    });
    for (const ht of $fourthHack) {
        $(ht).html("");
        render(_jsx(DataMaskingDunsComponent, { dnbUpikPath: maskingProperties.dnbUpikPath }), ht);
    }
};
export { dataMasking, DataMaskingComponent, DataMaskingCreditReportsComponent, MaskDynamicComponent, DataMaskingDunsComponent };
